<template>
  <router-view />
</template>

<script>
export default {
  name: 'AffiliatesStatistics',
  data: () => ({
    items: [
      {
        title: 'Monthly Reporting',
        route: 'monthly-statistics'
      },
      {
        title: 'Yearly Reporting',
        route: 'yearly-statistics'
      },
      {
        title: 'Lifetime Report',
        route: 'lifetime-statistics'
      },
    ],
  })
}
</script>

<style scoped>

</style>
